import semver from 'semver';
import javascriptBridge from '@/core/lib/javascript-bridge';

/**
 * 是否满足版本范围
 * @param {String} range 版本范围
 */
export function satisfiesAppVersion(range) {
  const { swjApp, swjAppVersion } = javascriptBridge.device;
  if (!swjApp || typeof range !== 'string') {
    return undefined;
  }
  return semver.satisfies(swjAppVersion, range);
}

/**
 * 兼容APP版本事件方法
 * @param {Array<Object>} versionEvents 版本事件
 * index: versionEvents.index 版本兼容的事件下标
 * versionEvents[index].version 版本号或版本范围，例如：1.0.0 或 >1.2.0
 * versionEvents[index].platform app平台可选值'android'和'ios'，不填代表不区分平台
 * versionEvents[index].run 执行事件
 * @param {Object} thisArg
 */
export function compatibleAppVersion(versionEvents = [], thisArg = this) {
  const { device } = javascriptBridge;
  const { swjApp } = device;
  if (!swjApp || !versionEvents || versionEvents.length === 0) {
    return;
  }
  (versionEvents || []).forEach((item) => {
    const { version, platform, run } = item;
    const checkedPlatform = !platform || (['android', 'ios'].includes(platform) && device[platform]);
    if (satisfiesAppVersion(version) && checkedPlatform) {
      run.apply(thisArg);
    }
  });
}
